import { useMemo, useState } from 'react';

import useAuthStore from '../../../store/useAuthStore';
import strings from '../../../constants/strings.constants';
import Typo from '../../../components/atom/Typo';
import { Reveal } from 'react-awesome-reveal';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTER_PATHS } from '../../../routes/routes.constatns';
import AuthBottomSheet from '../../../components/compositions/AuthBottomSheet/AuthBottomSheet';
import { getPartnerName } from '../../../utils/utils';

import { ReactComponent as BgWelcome } from '../../../assets/svgs/bg-welcome.svg';
import ReservationMenuBottomSheet from './components/ReservationMenuBottomSheet';
import {
  renderButtons,
  renderCustomLandingPage,
  revealTransition,
} from './renderer-utils';
import { sendViewItemListEvent } from '../../../utils/ga-utils';

function ReservationLandingPage() {
  const { customer, partner, clearCustomer } = useAuthStore();
  const [searchParams] = useSearchParams();
  const [reservationMenuVisible, setReservationMenuVisible] = useState(
    searchParams.get('rOpen') === 'true',
  );

  const customLabel =
    partner?.productViewConfig?.mimoWebViewConfig?.customLabel;

  const navigate = useNavigate();
  const location = useLocation();
  const [authModalVisible, setAuthModalVisible] = useState(false);
  const partnerDisplayName = useMemo(() => getPartnerName(partner), [partner]);

  const removeTokenQueryAndReplace = () => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.has('token')) {
      console.log('REDIRECT');
      queryParams.delete('token');
      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString(),
        },
        {
          replace: true,
        },
      );
    }
  };

  const routeReservationHistories = () => {
    navigate({
      pathname: ROUTER_PATHS.RESERVATION_HISTORIES,
      search: location.search,
    });
  };

  const handleEventMenuClick = () => {
    const queryParams = new URLSearchParams(location.search);
    if (partner?.productViewConfig?.mimoWebViewConfig?.useEventOnlyFilter) {
      queryParams.set('event', 'true');
    }
    sendViewItemListEvent({ itemListName: 'EVENT' });
    navigate({
      pathname: ROUTER_PATHS.EVENT_TREATMENT_RESERVATION,
      search: queryParams.toString(),
    });
  };

  const handleBookAppointmentClick = () => {
    setReservationMenuVisible(true);
  };

  const handleReservationHistoriesClick = () => {
    if (customer) {
      routeReservationHistories();
    } else {
      setAuthModalVisible(true);
    }
  };

  const renderLanding = () => {
    // Custom 페이지 (파트너별 별도 랜딩)
    const customLandingPage = renderCustomLandingPage(
      partner?.partnerCode,
      {
        onEventMenuClick: handleEventMenuClick,
        onBookAppointmentClick: handleBookAppointmentClick,
        onReservationHistoriesClick: handleReservationHistoriesClick,
      },
      partner,
    );
    if (customLandingPage) {
      return customLandingPage;
    }

    return (
      <div className="flex flex-col justify-center h-full overflow-y-auto">
        <Reveal
          keyframes={revealTransition}
          duration={300}
          className="flex flex-col min-h-0"
        >
          <div className="flex flex-col min-h-0 px-[20px] py-5 gap-2">
            <div className="mb-4 flex flex-col gap-4">
              <Typo
                type="b-30"
                style={{
                  whiteSpace: 'pre-wrap',
                  lineHeight: '42px',
                  fontWeight: 500,
                }}
              >
                {(
                  customLabel?.reservationLandingGreeting ||
                  strings.reservationLandingGreeting
                ).replace('{partnerName}', partnerDisplayName)}
              </Typo>
              <Typo
                type="r-18"
                style={{
                  whiteSpace: 'pre-wrap',
                  lineHeight: '25px',
                  fontWeight: 300,
                }}
              >
                {customLabel?.reservationLandingDescription ||
                  strings.reservationLandingDescription}
              </Typo>
            </div>
            {/* 콘텐츠가 길면 이미지가 줄어들어 여백과 나머지 콘텐츠 높이를 보장 */}
            <div className="flex flex-row-reverse flex-1 min-h-0 max-h-[277px] mb-[-8px]">
              <BgWelcome className="h-full w-auto" />
            </div>
            {renderButtons(
              {
                onEventMenuClick: handleEventMenuClick,
                onBookAppointmentClick: handleBookAppointmentClick,
                onReservationHistoriesClick: handleReservationHistoriesClick,
              },
              partner,
            )}
            {customer && (
              <button
                className="text-center text-[12px] text-gray-500 mt-2 underline"
                onClick={() => {
                  clearCustomer();
                  removeTokenQueryAndReplace();
                }}
              >
                {strings.logout}
              </button>
            )}
          </div>
        </Reveal>
      </div>
    );
  };

  return (
    <>
      {renderLanding()}
      <AuthBottomSheet
        visible={authModalVisible}
        onCancel={() => {
          setAuthModalVisible(false);
        }}
        onAuthComplete={() => {
          routeReservationHistories();
        }}
      />
      <ReservationMenuBottomSheet
        visible={reservationMenuVisible}
        onCancel={() => {
          setReservationMenuVisible(false);
        }}
      />
    </>
  );
}

export default ReservationLandingPage;
